import { render, staticRenderFns } from "./CRMLawcasePreservation.vue?vue&type=template&id=93697dbe&scoped=true&"
import script from "./CRMLawcasePreservation.vue?vue&type=script&lang=js&"
export * from "./CRMLawcasePreservation.vue?vue&type=script&lang=js&"
import style0 from "./CRMLawcasePreservation.vue?vue&type=style&index=0&id=93697dbe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93697dbe",
  null
  
)

export default component.exports